import { gql } from "@apollo/client/core";

/**
 * This file is generated from the metadata.json file. 
 * ** DO NOT edit this file manually **
 *
 * @example
 * ```
 * this.apollo.mutate({
 *     mutation: BULK_DOWNLOAD_INVOICES,
 *     variables: {
 *         bulkDownloadInvoicesRequest: bulkDownloadInvoicesRequest
 *     }
 * });
 * ```
 */
export const BULK_DOWNLOAD_INVOICES = gql`
mutation BULK_DOWNLOAD_INVOICES ($bulkDownloadInvoicesRequest: BulkDownloadInvoicesRequest!) {
    BulkDownloadInvoices(bulkDownloadInvoicesRequest: $bulkDownloadInvoicesRequest) {
        response
    }
}`;
